export default __webpack_public_path__ + "static/media/question-mark.b41d27ed.svg";